import { Injectable } from "@angular/core";
import { Request } from "@core/models/requests.model";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root',
})
export class AIRequest extends Request {
  override baseUrl: string = environment.API_URL_IA_TEXT;
}
